<template>
    <div id="webList">
        <div class="list">
            <div
                class="item"
                :class="{ 'is-selected': selectItem && selectItem[showKey] === item[showKey] }"
                v-for="(item, index) in listData"
                :key="index"
                @click="() => itemClickHandler(item)"
            >
                <span v-if="showFlag && flagOf(item)" class="flag" aria-hidden="true">{{ flagOf(item) }}</span>
                <div class="text">
                    <span class="item-title">{{ item[showKey] }}</span>
                    <span v-if="secondaryKey && item[secondaryKey] && item[secondaryKey] !== item[showKey]" class="item-sub">
                        {{ item[secondaryKey] }}
                    </span>
                </div>
                <span v-if="selectItem && selectItem[showKey] === item[showKey]" class="check" aria-hidden="true"></span>
            </div>
        </div>
    </div>
</template>
<script>
import { flagForLanguage } from "../utils/languageFlags";
export default {
    name: "WebList",
    props: {
        listValue: { default: [] },
        showKey: { default: "" },
        secondaryKey: { default: null },
        searchValue: { default: null },
        defaultSelected: { default: null },
        showFlag: { type: Boolean, default: false },
    },
    data() {
        return {
            selectItem: null,
            listData: this.listValue,
        };
    },
    methods: {
        flagOf(item) {
            return flagForLanguage(item && item.code);
        },
        itemClickHandler(item) {
            this.selectItem = item;
            this.$emit("itemClicked", item);
        },
    },
    watch: {
        searchValue() {
            if (this.searchValue === null) return;
            this.listData = this.listValue.filter((item) =>
                item[this.showKey].toLowerCase().includes(this.searchValue.toLowerCase())
            );
        },
    },
    mounted() {
        if (this.defaultSelected !== null) {
            this.selectItem = this.listData.find((item) => item[this.showKey] === this.defaultSelected[this.showKey]);
        }
    },
};
</script>
<style lang="scss">
#webList {
    width: 100%;

    .list {
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        padding-bottom: 40px;

        // Kompakt satir: bayrak + ad, aralarinda ince ayirici
        .item {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 9px 20px;
            min-height: 44px;
            cursor: pointer;
            user-select: none;
            border-bottom: 1px solid rgba(15, 23, 42, 0.06);
            transition: background-color 120ms ease;

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                background-color: rgba(15, 23, 42, 0.04);
            }

            &.is-selected {
                background-color: rgba(15, 23, 42, 0.03);
            }

            .flag {
                font-size: 18px;
                line-height: 1;
                width: 22px;
                flex-shrink: 0;
                text-align: center;
            }

            .text {
                flex: 1;
                min-width: 0;
                display: flex;
                flex-direction: column;
                gap: 1px;

                .item-title {
                    color: var(--primary-text);
                    font-size: 14px;
                    font-weight: 500;
                    line-height: 1.3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .item-sub {
                    color: var(--primary-text);
                    opacity: 0.5;
                    font-size: 11.5px;
                    line-height: 1.3;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            // Secili isareti: ayri bir buton bileseni yerine cizilen tik
            .check {
                flex-shrink: 0;
                width: 12px;
                height: 7px;
                margin-right: 2px;
                border-left: 2px solid var(--button-color);
                border-bottom: 2px solid var(--button-color);
                transform: rotate(-45deg);
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/common/WebList.vue